import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { RightOfWayExact } from '../../../../../mission/models/RightOfWay';

const RightOfWayTreeView = ({ rightOfWays, setRightOfWays, setCenteredGeometries, disabled }) => {
  const handleRightOfWaysCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(rightOfWays, item.id));
    },
    [rightOfWays, setCenteredGeometries]
  );

  const handleRightOfWaysVisibilityClick = useCallback(
    (item, isToggled) => {
      setRightOfWays((oldRightOfWays) => getEntitiesWithVisibility(oldRightOfWays, item.id, isToggled));
    },
    [setRightOfWays]
  );

  const { current: rightOfWayItemActions } = useRef([
    { id: 'right-of-way-center', icons: { default: 'gps_fixed' }, onClick: handleRightOfWaysCenterClick },
    {
      id: 'right-of-way-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleRightOfWaysVisibilityClick,
    },
  ]);

  const rightOfWayItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('mission.details.rightOfWays')}: ${rightOfWays.length}`,
        actions: rightOfWayItemActions,
        disabled,
        children: rightOfWays.map((row, index) => ({
          id: index,
          label: `${i18n.t('mission.details.rightOfWay')} #${index + 1}`,
          actions: rightOfWayItemActions,
          disabled,
        })),
      },
    ],
    [disabled, rightOfWayItemActions, rightOfWays]
  );

  return <TreeView id="rightOfWays" items={rightOfWayItems} />;
};

RightOfWayTreeView.propTypes = {
  rightOfWays: PropTypes.arrayOf(RightOfWayExact),
  setRightOfWays: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RightOfWayTreeView.defaultProps = {
  rightOfWays: [],
  disabled: false,
};

export default RightOfWayTreeView;
